import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'i18n',
  setup(__props) {

const changes = {}
const onChange = (k, v) => {
  changes[k] = v
}

return { __sfc: true,changes, onChange }
}

})